import Text from './text';
import Number from './number';
import Paragraph from './paragraph';
import Checkbox from './checkbox';
import Dropdown from './dropdown';
import RadioButton from './radio-button';
import ImageUpload from './image-upload';
import MultipleImageUpload from './multiple-image-upload';
import ImageCapture from './image-capture';
import MultipleImageCapture from './multiple-image-capture';
import LocationMap from './location-map';
import LocationStamp from './location-stamp';
import VoiceRecord from './voice-record';
import Email from './email';
import PhoneNumber from './phone-number';
import Date from './date';
import DateTime from './date-time';
import Range from './range';
import YesNo from './yes-no';
import Information from './information';
import TagList from './tag-list';
import Ordering from './ordering';
import VideoCapture from './video-capture';

export default [
  Text,
  Number,
  Paragraph,
  Checkbox,
  Dropdown,
  RadioButton,
  ImageUpload,
  MultipleImageUpload,
  ImageCapture,
  MultipleImageCapture,
  LocationMap,
  LocationStamp,
  VoiceRecord,
  Email,
  PhoneNumber,
  Date,
  DateTime,
  Range,
  YesNo,
  Information,
  TagList,
  Ordering,
  VideoCapture
];



// WEBPACK FOOTER //
// ./src/components/task-form/question-types/index.js